module.exports = __webpack_public_path__ + "static/img/solution-1.35470b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution-1.png
// module id = dVip
// module chunks = 0